import {Box, Button, CircularProgress, Dialog, DialogContent, DialogTitle, Stack, Typography} from "@mui/material";
import EntityActions from "crqlar-react-common/dist/components/EntityActions";
import {useEntity} from "crqlar-react-common/dist/components/useEntity";
import type {Profile} from "crqlar-react-common/dist/models/profile/profile.model";
import {MixpanelService} from "crqlar-react-common/dist/services/analytics/mixpanel.service";
import {ProfileService} from "crqlar-react-common/dist/services/profile/profile.service";
import {useTranslation} from "react-i18next";
import ProfileDetailsForm from "./profileDetailsForm/ProfileDetailsForm";

interface ProfileCreateDialogProps {
    open: boolean;
    onClose: () => void;
    onCreated: (profile: Profile) => void;
}

const ProfileCreateDialog = ({open, onClose, onCreated}: ProfileCreateDialogProps) => {
    const {t} = useTranslation();
    const profileData = useEntity<Profile>({
        get: async () => ({}),
        create: ProfileService.createProfile,
        update: ProfileService.updateProfile,
        onSaved: (profile, wasCreateAction) => {
            if (wasCreateAction) {
                MixpanelService.getInstance().track("create profile");
            }
            onCreated(profile);
        },
    }, "new");

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
            aria-labelledby="create-profile-dialog-title"
        >
            <DialogTitle id="create-profile-dialog-title">
                <Stack
                    direction={{xs: "column", sm: "row"}}
                    justifyContent="space-between"
                    alignItems={{xs: "stretch", sm: "center"}}
                    gap={2}
                >
                    <Typography variant="h6">{t("Create profile")}</Typography>
                    <Stack direction="row" gap={1} justifyContent={{xs: "flex-end", sm: "initial"}}>
                        <EntityActions
                            data={profileData}
                            labels={{save: t("Create profile")}}
                        />
                        <Button variant="outlined" onClick={onClose} disabled={profileData.saving}>
                            {t("Cancel")}
                        </Button>
                    </Stack>
                </Stack>
            </DialogTitle>

            <DialogContent dividers sx={{p: 0, minHeight: 440}}>
                {profileData.loading ? (
                    <Box sx={{display: "grid", placeItems: "center", minHeight: 440}}>
                        <CircularProgress size={28}/>
                    </Box>
                ) : (
                    <Box sx={{width: "100%", maxWidth: 900, mx: "auto", p: {xs: 2, sm: 3}}}>
                        <ProfileDetailsForm profileData={profileData}/>
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default ProfileCreateDialog;
